// extracted by mini-css-extract-plugin
export var active = "_p-9";
export var backButton = "_p-8";
export var clone = "_p-e";
export var collapseBar = "_p-k";
export var collapseMode = "_p-m";
export var collapsed = "_p-o";
export var dimmed = "_p-i";
export var dragHandle = "_p-c";
export var dropdownIcon = "_p-g";
export var expanding = "_p-n";
export var hidden = "_p-x";
export var iconContainer = "_p-q";
export var iconSwapper = "_p-w";
export var navItem = "_p-6";
export var navItemIcon = "_p-f";
export var navProfile = "_p-7";
export var notificationCountBadge = "_p-j";
export var notificationDot = "_p-r";
export var optionsContainer = "_p-h";
export var primaryNav = "_p-0";
export var primaryNavDivider = "_p-v";
export var primaryNavResizeHandle = "_p-2";
export var primaryNavResizing = "_p-1";
export var primaryNavTabSection = "_p-u";
export var primaryTab = "_p-p";
export var primaryTabIconBox = "_p-s";
export var secondaryNav = "_p-3";
export var selected = "_p-t";
export var settingsNav = "_p-4";
export var settingsNavItems = "_p-5";
export var show = "_p-d";
export var sideNav = "_p-l";
export var teamItem = "_p-a";
export var userProfileItem = "_p-b";